import React, { Component } from 'react';
import PropTypes from 'prop-types';
import swal from '@sweetalert/with-react';
import API from '../../../services/api';

// Components

import ExamRoleList from './list';

import ExamRoleForm from './form';

import ExamContainer from '../../Exam';

// Styles

import { SubContainer, SubContent } from '../styles';

class ExamRoleContainer extends Component {
  state = {
    isLoading: true,

    examRoles: null,

    exams: null,

    examModal: false,
  };

  async componentDidMount() {
    this.mount();
  }

  mount() {
    this.getExamRoles();

    this.getExams();
  }

  async getExamRoles() {
    this.setState({
      isLoading: true,
    });

    const { role } = this.props;

    API.get(`examroles/list/${role.uuid}`).then(res => {
      const result = res.data;

      this.setState({
        examRoles: result,

        isLoading: false,
      });
    });
  }

  handleExamRoleCreation = async values => {
    const { role } = this.props;

    try {
      await API.post(
        'examroles',

        {
          examUuid: values.examUuid,
          roleUuid: role.uuid,
        },

        {
          headers: { 'Content-Type': 'application/json' },
        }
      ).catch(error => {
        throw error;
      });

      this.getExamRoles();
    } catch (err) {
      alert(err);
    }
  };

  async getExams() {
    this.setState({
      isLoading: true,
    });

    API.get(`exams`).then(res => {
      const result = res.data;

      this.setState({
        exams: result,

        isLoading: false,
      });
    });
  }

  handleExamRoleDelete = async uuid => {
    const confirmDelete = await swal({
      dangerMode: true,

      text: 'Confirma a exclusão de Exame?',

      buttons: {
        cancel: 'Não',

        confirm: 'Sim',
      },
    });

    if (confirmDelete) {
      API.delete(`examroles/${uuid}`).then(() => {
        this.getExamRoles();
      });
    }
  };

  // Exams

  handleExamsList = list => {
    this.setState({
      exams: list,
    });
  };

  render() {
    const { isLoading, examRoles, exams, examModal } = this.state;

    return (
      <SubContainer>
        <header>
          <h1>FUNÇÕES</h1>

          <button
            type="button"
            onClick={() => {
              this.setState({ examModal: !examModal });
            }}
          >
            NOVO EXAME
          </button>
        </header>

        <SubContent>
          <ExamContainer
            onExamsList={this.handleExamsList}
            onExamCreation={() => this.setState({ examModal: !examModal })}
            visible={examModal}
          />

          <ExamRoleList
            isLoading={isLoading}
            onExamRoleDelete={this.handleExamRoleDelete}
            examRoles={examRoles}
          />

          <ExamRoleForm
            onExamRoleCreation={this.handleExamRoleCreation}
            exams={exams}
          />
        </SubContent>
      </SubContainer>
    );
  }
}

ExamRoleContainer.propTypes = {
  role: PropTypes.shape({
    uuid: PropTypes.string,
  }).isRequired,
};

export default ExamRoleContainer;
